import { InvoiceProjectDto } from './invoiceProject.dto';
import { InvoiceStatusDto } from './invoiceStatus.dto';
import { BaseDto } from './base.dto';
import { CurrencyDto } from './currency.dto';
import { InvoiceItemDto } from './invoiceItem.dto';
import { InvoicePaymentDto } from './invoicePayment.dto';
import { InvoiceOriginEnum } from '@up/data';

export class InvoiceDto extends BaseDto {
  merchantId: number;
  invoiceName: string;
  invoiceNumber: string;
  invoiceFrom: string;
  invoiceToName: string;
  invoiceToEmail: string;
  invoiceIssuedDate: Date;
  invoiceIssuedDateConverted: string;
  invoiceDueDate: Date;
  invoiceDueDateConverted: string;
  invoicePaymentLink: string;
  invoiceTotalVatAmount: number;
  invoiceTotal: number;
  invoiceNote: string;
  invoiceAdditionalNote: string;
  invoiceCode: string;
  webPaymentCode?: string;
  project?: InvoiceProjectDto;
  currency: CurrencyDto;
  invoiceStatus: InvoiceStatusDto;
  invoiceItems?: InvoiceItemDto[];
  invoicePayments?: InvoicePaymentDto[];
  merchantBusinessEntityId?: number;
  invoiceOrigin?: InvoiceOriginEnum | string;
  merchantBusinessName?: string;
  merchantBusinessAddress?: string;
  merchantBusinessVatNumber?: string;
  entityName?: string;
  entityAddress?: string;
  entityVatNumber?: string;
  proformaChecked?: boolean;
}
